import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { useEffect, useState } from "react";
import { Offer } from "./model";
import { fetch } from "@/src/lib/fetch";
import { DataTable } from "../../components/ui/data-table";
import { ColumnDef } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";

export const OfferVersionsModal = ({
  open,
  setOpen,
  hubspotId,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  hubspotId?: string;
}) => {
  const [offers, setOffers] = useState<Offer[] | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    async function getVersions() {
      await fetch<{ offers: Offer[]; total: number }>(`/api/offers/${hubspotId}/versions`).then((r) => {
        setOffers(r.offers);
      });
    }
    open && !offers?.length && getVersions();
  }, [open]);

  if (!offers) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-[724px] max-h-[calc(100vh-120px)] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl flex flex-col">Offer versions</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-3">
          <DataTable
            columns={columns}
            data={offers}
            onRowClick={(r) => {
              setOpen(false);
              navigate(`/offers/${r.id}`);
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const columns: ColumnDef<Offer>[] = [
  {
    id: "number",
    cell: ({ row }) => <span>{row.index + 1}</span>,
  },
  {
    header: "Status",
    cell: ({ row }) => (
      <span className="flex bg-blue-50 w-max rounded-[25px] py-1.5 px-3 leading-4">
        {row.original.status[0].toUpperCase()}
        {row.original.status.split("_").join(" ").substring(1)}
      </span>
    ),
  },
  {
    header: "Budget",
    accessorKey: "budget",
  },
  {
    header: "Created",
    accessorFn: (r) =>
      r?.dateCreated &&
      new Date(r?.dateCreated).toLocaleDateString("en-EN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }),
  },
  {
    header: "Updated",
    accessorFn: (r) =>
      r?.dateUpdated &&
      new Date(r?.dateUpdated).toLocaleDateString("en-EN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }),
  },
];
